


























import { defineComponent, reactive, SetupContext, computed, onMounted, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";

interface Data {
  dragAreaText: string
  targetSheetType: number | string
  isApprovalExamFlow: boolean
  errors: string[];
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "drop-area": DropArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      dragAreaText: null,
      targetSheetType: "",
      isApprovalExamFlow: false,
      errors: [],
    });

    /******************************
     * 戻るボタン押下
     ******************************/

    const goBack = (): void => {
      context.root.$router.go(-1);
    };

    /******************************
     * アップロードAPI
     ******************************/

    const upload = async (file: File[]): Promise<void> => {

      if(state.targetSheetType === ""){
        state.errors = ["試験種別を選択してください。"];
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', file[0]);
      fd.append("sheet_type", String(state.targetSheetType));

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post("/api/teacher/ikkatsu_correct_image_upload/upload", fd).then(response => {
        alert("アップロードが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 帳票種別に応じたアップロード案内を設定
     ******************************/
    
    const setDragAreaText = () => {
      // 教材は模範解答なし
      if(state.targetSheetType == Common.SheetTypeEnum.Report){
        state.dragAreaText = `
          模範解答のJPEG又はPDFをZIP形式に圧縮して、コチラにドラッグ&ドロップしてください。（ファイルの拡張子は複数混在できません）<br>
          JPEGのファイル命名規則：ra + QRコード + ページ番号(0埋2桁).jpg　例＞ra22001100010101.jpg<br>
          PDFのファイル命名規則：ra + QRコード.pdf　例＞ra220011000101.jpg
        `
      }else if(state.targetSheetType == Common.SheetTypeEnum.LessonTest){
        state.dragAreaText = `
          模範解答のJPEG又はPDFをZIP形式に圧縮して、コチラにドラッグ&ドロップしてください。（ファイルの拡張子は複数混在できません）<br>
          JPEGのファイル命名規則：ta + 講座コード + 回次(0埋3桁) + ページ番号(0埋2桁).jpg　例＞taSU010100201.jpg<br>
          PDFのファイル命名規則：ta + 講座コード + 回次(0埋3桁).pdf　例＞taSU0101002.pdf
        `
      }else if(Common.isApprovalExamSheetType(state.targetSheetType)){
        state.dragAreaText = `
          模範解答のJPEG又はPDFをZIP形式に圧縮して、コチラにドラッグ&ドロップしてください。（ファイルの拡張子は複数混在できません）<br>
          JPEGのファイル命名規則：sa + QRコード + ページ番号(0埋2桁).jpg　例＞sa22001100010101.jpg<br>
          PDFのファイル命名規則：sa + QRコード.pdf　例＞sa220011000101.pdf
        `
      }else{
        state.dragAreaText = "試験種別を選択してから、ファイルをアップロードしてください。";
      }
    };

    /******************************
     * mounted
     ******************************/

    onMounted(async () => {
      state.isApprovalExamFlow = Common.isApprovalExamSheetType(context.root.$store.state.sheet_type);
      state.targetSheetType = state.isApprovalExamFlow ? "" : context.root.$store.state.sheet_type;
      setDragAreaText();
    });

    return {
      ...toRefs(state),
      goBack,
      upload,
      setDragAreaText,
      Common,
    };
  },
})
